module.exports = function getResource(label, vars = []) {
    const resources = {
        installments: `Crédit offert par ${vars[0]}`,
        testCardDiscount: `or ${vars[0]} off your Sephora order when you open and use a Sephora Credit Card today.¹`,
        testCardDiscountBasketText: `or ${vars[0]} off when you open and use your Sephora Credit Card on this purchase today.¹`,
        testSeeDetails: 'Voir les détails',
        learnMore: 'En savoir plus',
        testCreditCardMessageBody: 'Earn 4% back in rewards when you use your Sephora Credit Card at Sephora.'
    };

    return resources[label];
};
